
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { ConstructionSearchParam } from '../models/ConstructionSearchParam';
import { DispatchSearch } from '../DispatchSearch';
import { CommonParam } from '../models/CommonParam';
import { BehaviorSubject } from 'rxjs';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { CnstPMConfirmSaveParam } from '../models/CnstPMConfirmSaveParam';
import { CnstContWIPCommitSaveParam } from '../models/CnstContWIPCommitSaveParam';
import { CnstPMMarkCompleteParam } from '../models/CnstPMMarkCompleteParam';
import { RefreshToken } from '../models/RefreshToken';

@Injectable()
export class ConstructionService extends BaseService {

  constructor(_http: HttpClient) {
    super(_http);
    this.baseUrl = this.rootUrl + "Construction/";
    }

    // Subject used to broadcast refresh events to child components 
    refreshSubject: Subject<RefreshToken> = new Subject<RefreshToken>();

    openContractInfo: BaseMessageInfo = null;
    private openContractInfoData = new BehaviorSubject<BaseMessageInfo>(this.openContractInfo);
    openContractInfoData$ = this.openContractInfoData.asObservable();
    private openContractDataInProg: boolean = false;
    openContractInfoTimeStamp: number;

    setOpenContractInfoData(data: BaseMessageInfo) {
        this.openContractInfoData.next(data);
    }

    getConstructionJobInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetConstructionJobInfo"
        return this._http.get(url_call, options);
    }
    getConstructionContractInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetConstructionContractInfo";
        return this._http.get(url_call, options);
    }
    getDynamicOpenContractInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetDynamicOpenContractInfo";

        if (!this.openContractDataInProg) {
            this.openContractDataInProg = true;
            this._http.get(url_call, options).subscribe(data => {
                this.openContractDataInProg = false;

                this.setOpenContractInfoData(data);
            });
        }
        return this.openContractInfoData$;
    }
    getSingleDynamicOpenContractInfo(param: ConstructionSearchParam): string {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetDynamicOpenContractInfo";

        //this.openContractDataInProg = true;
        this._http.get(url_call, options).subscribe(data => {

            var temData =  this.openContractInfoData.value
            if (!data.saveError) {
                var temDataArray = temData.primaryReturn;
                    var index = temDataArray.findIndex((element) => { return element.contractId === param.contractId });
                    if (data.primaryReturn && data.primaryReturn.length>0) {
                        //data.primaryReturn.forEach(item => {
                        //    temDataArray[index]=item;
                        //});
                        temDataArray[index] = data.primaryReturn[0];
                    }
                temData.primaryReturn = temDataArray;
                this.setOpenContractInfoData(temData);
            }

        });
        return "Done";
    }
    getPMBoardInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "getPMBoardInfo";
        return this._http.get(url_call, options);
    }
    savePMConfirmation(data: CnstPMConfirmSaveParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePMConfirmation";
        return this._http.put(url_call, data, { headers });
    }
    savePMMarkComplete(data: CnstPMMarkCompleteParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePMMarkComplete";
        return this._http.put(url_call, data, { headers });
    }
    getWipReportInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "getWipReportInfo";
        return this._http.get(url_call, options);
    }
    getContractWipReportInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "getContractWipReportInfo";
        return this._http.get(url_call, options);
    }
    saveContractWipCommit(data: CnstContWIPCommitSaveParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "saveContractWipCommit";
        return this._http.put(url_call, data, { headers });
    }
    getContractWIPCommits(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetContractWIPCommits";
        return this._http.get(url_call, options);
    }
    getEquipBoardInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetEquipBoardInfo";
        return this._http.get(url_call, options);
    }
    getDynamicConstructionContractInfo(param: ConstructionSearchParam): Observable<any> {
        var s_search = JSON.stringify(param);
        let options = this.getOptionsU('', "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetDynamicWIPContractBoard";
        return this._http.get(url_call, options);
    }
    getContractInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractInfo/" + id
        return super.get(url_call);
    }
    getContractInfoOnly(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractInfoOnly/" + id
        return super.get(url_call);
    }
    getOrdersByContract(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetOrdersByContract/" + id
        return super.get(url_call);
    }
    getContractInfoOther(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractInfoOther/" + id
        return super.get(url_call);
    }
    getContractsBySearch(search: DispatchSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsUL('', '', "search", s_search);
        let url_call: string = this.baseUrl + "GetContractsBySearch";

        return this._http.get(url_call, options);
    }

    getContractJobs(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractJobs/" + id
        return super.get(url_call);
    }
    getConstJob(id: string): Observable<BaseMessageInfo> {
        let url_call: string = this.baseUrl + "GetConstJob/" + id
        return super.get(url_call);
    }
    createDraw(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "CreateDraw/" + id
        return super.get(url_call);
    }
    createDrawWithHeaderOnly(id: any): Observable<any> {
        let url_call: string = this.baseUrl + "CreateDrawWithHeaderOnly/" + id
        return super.get(url_call);
    }
    jobSaveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "JobSaveAll";
        return this._http.put(url_call, model, { headers });
    }
    jobSave(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "JobSave";
        return this._http.put(url_call, model, { headers });
    }
    contractSaveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ContractSaveAll";
        return this._http.put(url_call, model, { headers });
    }
    contractSave(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ContractSave";
        return this._http.put(url_call, model, { headers });
    }
    getJobBlanketOrderRemaining(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetJobBlanketOrderRemaining/" + jobId
        return super.get(url_call);
    }
    getSubcoOrderBillDollarInfo(orderId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSubcoOrderBillDollarInfo/" + orderId
        return super.get(url_call);
    }
    getSubcoOrderDetails(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSubcoOrderDetails/" + jobId
        return super.get(url_call);
    }
    getConstProfitAnalysis(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetContractProfitAnalysis";
        return this._http.get(url_call, options);
    }
    GetSubJobList(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetSubJobList";
        return this._http.get(url_call, options);
    }
    GetProfitAnalysisByJobId(param: ConstructionSearchParam, id: string): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetProfitAnalysisByJobId/" + id;
        return this._http.get(url_call, options);
    }
    GetJobDrawsByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetJobDrawsByContractId";
        return this._http.get(url_call, options);
    }
    GetDynamicJobDrawsByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetDynamicJobDrawsByContractId";
        return this._http.get(url_call, options);
    }
    GetEquipmentDrawsByJobId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetEquipmentDrawsByJobId";
        return this._http.get(url_call, options);
    }
    GetJobSummaryByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetJobSummaryByContractId";
        return this._http.get(url_call, options);
    }
    GetPostJobWarrantyByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetPostJobWarrantyByContractId";
        return this._http.get(url_call, options);
    }
    GetCostDetailsByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetCostDetailsByContractId";
        return this._http.get(url_call, options);
    }
    GetCostDetailOrdersByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetCostDetailOrdersByContractId";
        return this._http.get(url_call, options);
    }
    GetCostDetailsByJobId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetCostDetailsByJobId";
        return this._http.get(url_call, options);
    }
    GetPostWarrantyByContractId(param: ConstructionSearchParam): Observable<any> {
        let s_search: string = JSON.stringify(param);
        let options = this.getOptionsU("", "cnstsearchparam", s_search);
        let url_call: string = this.baseUrl + "GetPostJobWarrantyByContractId";
        return this._http.get(url_call, options);
    }
    getAdditionalJobData(jobId: any, contractId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalJobData/" + jobId + "/" + contractId;
        return super.get(url_call);
    }
    getChangeOrderParentJob(masterJobId: any, accountClassId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetChangeOrderParentJob/" + masterJobId + "/" + accountClassId;
        return super.get(url_call);
    }
    checkContractStatusChange(contractId: any, dispatchStatusId: any): Observable<any> {
        let url_call: string = this.baseUrl + "CheckContractStatusChange/" + contractId + "/" + dispatchStatusId;
        return super.get(url_call);
    }
    checkJobStatusChange(jobId: any, dispatchStatusId: any): Observable<any> {
        let url_call: string = this.baseUrl + "CheckJobStatusChange/" + jobId + "/" + dispatchStatusId;
        return super.get(url_call);
    }
    createNewJobFromQuote(quoteId: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateNewJobFromQuote/" + quoteId;
        return super.get(url_call);
    }
    getVendorCreditsByContract(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetVendorCreditsByContract/" + id;
        return super.get(url_call);
    }
    validateOpenJobs(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "ValidateOpenJobs";
        return this._http.get(url_call, options);
    }
    getConstPOInformation(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetConstPOInformation";
        return this._http.get(url_call, options);
    }
    GetConstPOSubInformation(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetConstPOSubInformation";
        return this._http.get(url_call, options);
    }
    getConstPOInformationReference(): Observable<any> {
        let url_call: string = this.baseUrl + "GetConstPOInformationReference";
        return super.get(url_call);
    }
    getInvoicesByContract(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoicesByContract/" + id
        return super.get(url_call);
    }
    getContactJobCosts(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContactJobCosts/" + id
        return super.get(url_call);
    }

    getConstHistory(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetConstHistory";
        return this._http.get(url_call, options);
    }
    getJobDefaultsFromQuote(quoteId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetJobDefaultsFromQuote/" + quoteId;
        return super.get(url_call);
    }
    getQuoteEstimator(quoteId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteEstimator/" + quoteId;
        return super.get(url_call);
    }
    getQuoteEstimatorFromJobId(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuoteEstimatorFromJobId/" + jobId;
        return super.get(url_call);
    }
    getDispatchContAdjustments(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractAdjustments/" + jobId
        return super.get(url_call);
    }
    getDispatchCostAdjustments(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchCostAdjustments/" + jobId
        return super.get(url_call);
    }
    getContractDispatchCostAdjustments(contractId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetContractDispatchCostAdjustments/" + contractId
        return super.get(url_call);
    }
    getDispatchCurrCostAdjustments(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCurrentCostAdjustments/" + jobId
        return super.get(url_call);
    }
    getDispatchBTDAdjustments(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetBTDAdjustments/" + jobId
        return super.get(url_call);
    }
    getDispatchSixZeroSixAdjustments(jobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetSixZeroSixAdjustments/" + jobId
        return super.get(url_call);
    }
    saveDispatchContAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveContractAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchCostAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchCostAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchCurrCostAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveCurrentCostAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchSOWAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSOWAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchBTDAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveBTDAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchSixZeroSixAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSixZeroSixAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchPMCompleteAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePMCompleteAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchEquipmentAdjustment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchEquipmentAdjustment";
        return this._http.put(url_call, model, { headers });
    }
    getDQOIItem(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDQOIItem/" + id
        return super.get(url_call);
    }
    canSetJobBackToService(dispatchJobId: string): Observable<any> {
        let url_call: string = this.baseUrl + "CanSetJobBackToService/" + dispatchJobId;
        return super.get(url_call);
    }
    markProjectComplete(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "MarkProjectComplete";
        return this._http.get(url_call, options);
    }

    getConstructionBidStatus(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetConstructionBidStatus/" + id
        return super.get(url_call);
    }
}
